
export enum LeadIntent {
  PlaceBid= 'PlaceBid',
  DirectSaleBuy= 'DirectSaleBuy',
  DirectSaleProposal= 'DirectSaleProposal',
  DocumentDownload= 'DocumentDownload',

}